'use client';
import { ProductCardWrapper, ProductCardWrapperProps } from '@/entities/product/ui/product-card';

type Props = ProductCardWrapperProps;

export const MenuItemCard = (props: Props) => {
    return <ProductCardWrapper {...props} />;
};
